import { Fragment, useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import {
  clearAllNotificationMessage,
  getNotificationMessage,
} from "../../controllers/notification";
import { ConstructNotificationMessage } from "../../utils/getNotificationMessage";
import Loader from "../common/Loader";
import NoDataFound from "../common/NoDataFound";
import { UserContext } from "../common/UserContext";
import { NotificationsT } from "./NotificationBell";
import "./notifications.css";

function NotificationMessages() {
  const { authToken } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [notificationsList, setNotificationsList] = useState<NotificationsT[]>(
    []
  );
  const [activeCategory, setActiveCategory] = useState<"all" | "critical">(
    "critical"
  );

  const handleCategoryChange = (category: "all" | "critical") => {
    setActiveCategory(category);
  };

  const handleClearAll = () => {
    clearAllNotificationMessage(authToken).then(() => {
      setNotificationsList([]);
      setActiveCategory("critical");
    });
  };

  useEffect(() => {
    setLoading(true);
    const fetchNotifications = () => {
      getNotificationMessage(authToken)
        .then((res) => {
          const filteredData = res.data.filter(
            (notification: NotificationsT) => !notification.isCleared
          );
          setNotificationsList(filteredData);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 13000);
    return () => clearInterval(intervalId);
  }, [authToken]);

  const filteredNotifications =
    activeCategory === "all"
      ? notificationsList
      : notificationsList.filter((notification) => notification.critical);

  return (
    <div className="containerBox">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="header">
            <div className="title-div title-display">
              <p
                className="pad-button card-title"
                style={{ whiteSpace: "nowrap", margin: 0 }}
              >
                Notifications
              </p>
            </div>
          </div>
          <hr className="divider-line1" />
          <div
            style={{
              marginBottom: "10px",
              paddingLeft: "35px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <button
                onClick={() => handleCategoryChange("critical")}
                style={{
                  background:
                    activeCategory === "critical" ? "#007bff" : "#f0f0f0",
                  color: activeCategory === "critical" ? "#fff" : "#000",
                  border: "none",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Critical
              </button>
              <button
                onClick={() => handleCategoryChange("all")}
                style={{
                  background: activeCategory === "all" ? "#007bff" : "#f0f0f0",
                  color: activeCategory === "all" ? "#fff" : "#000",
                  border: "none",
                  padding: "5px 10px",
                  marginRight: "5px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                All
              </button>
            </div>
            <div style={{ paddingRight: "35px" }}>
              <button
                onClick={handleClearAll}
                style={{
                  background: "#007bff",
                  color: "#fff",
                  border: "none",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Clear All
              </button>
            </div>
          </div>
          {filteredNotifications.length === 0 ? (
            <NoDataFound message1="No Notifications found" message2="" />
          ) : (
            <div style={{ padding: "0px 35px 0px 35px" }}>
              <Table className="table" borderless>
                <tbody className="table-body">
                  {filteredNotifications.map((data) => {
                    return (
                      <Fragment key={data._id}>
                        <tr>
                          <td
                            style={{
                              borderBottom: "1px solid #ddd",
                              height: "50px",
                              verticalAlign: "middle",
                            }}
                          >
                            {ConstructNotificationMessage(data)}
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default NotificationMessages;
